import { Collection } from 'modules/core/lib/mobx-rest'

import Permission from 'modules/permissions/store/models/Permission'

class Permissions extends Collection<Permission> {
  get cacheKey(): string {
    return 'permissions'
  }

  model() {
    return Permission
  }

  upsert(data: Record<string, any>): Promise<any> {
    return this.rpc('upsert', data)
  }

  bulkUpsert(data: BulkUpsertOptions[]) {
    return this.rpc('bulk_upsert', {
      permissions: data,
      permissions_group_id: data[0]?.permissions_group_id,
    })
  }
}
interface BulkUpsertOptions {
  verb: string
  context: string
  permissions_group_id: string
  resource: string | null
  authorized: boolean
}

const singleton: Permissions = new Permissions()

export default singleton
